import React from 'react';
import { PromoPageView } from '../../components/PromoPageView/PromoPageView';

export const PromoPage = () => {
  return <PromoPageView />;
};
